import {memo, ReactNode} from 'react'
import {useGetNotificationCount} from '@/features/notifications/queries/useGetNotificationCount'
import {StyledNotificationBadge} from './style'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

interface NotificationBadgeProps {
    children: ReactNode
    onNotificationClickCb: () => void
}

const NotificationBadgeComponent = ({children, onNotificationClickCb, ...rest}: NotificationBadgeProps) => {
    const {data: countData, isLoading} = useGetNotificationCount()
    const count = countData?.toRead || 0

    return (
        <Flexbox {...rest} style={{position: 'relative', cursor: 'pointer'}} onClick={onNotificationClickCb}>
            {children}
            {!isLoading && count > 0 && (
                <StyledNotificationBadge align="center" justify="center">
                    {count > 99 ? '99+' : count}
                </StyledNotificationBadge>
            )}
        </Flexbox>
    )
}

export const NotificationBadge = memo(NotificationBadgeComponent)
